import { LogPointsApplicationsState } from '../LogPointsBody/LogPointsApplicationsBody/model'
import { MonitoringLocalStorage } from '../../../util/storage/MonitoringLocalStorageManager'
import { EnvironmentSelectorState } from '../../../common/environment/reducer'
import { LogPointsAPIState } from '../LogPointsBody/LogPointsAPIsBody/model'
import { ResourceSelectorState } from '../../../common/resource/reducer'
import { VersionSelectorState } from '../../../common/version/reducer'
import { FetchState } from '../../../common/redux/fetch/reducerFor'
import { LogPointsConnectors } from '../../../remote-api/models'
import { ExternalValueProps } from './LogPointsPage'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'

export const logPointsOrigin: keyof MonitoringLocalStorage = 'logPoints'
export const logPointsLandingOrigin = 'logPointsLandingPage'
export const CONNECTORS_ICONS_RESOURCE_NAME = 'connectors'
export const CONNECTORS_ICONS_PREFIX = 'connectors'

export type ConnectorsIconsFetcherState = FetchState<LogPointsConnectors>

export type LogPointsLandingState = {
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
}

export type LogPointsState = {
  landingPage: LogPointsLandingState
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
  apis: LogPointsAPIState
  apps: LogPointsApplicationsState
  connectors: ConnectorsIconsFetcherState
}

export enum LogPointsType {
  APPLICATION = 'Application',
  API = 'API'
}

export const getLogPointsResourceType = (props: ExternalValueProps): ResourceType => {
  // no RTF applications support in log points
  if (props.type === LogPointsType.API) return ResourceType.API
  if (props.targetId) return ResourceType.HYBRID_APPLICATION
  if (props.resourceId.includes('.')) return ResourceType.CLOUDHUB_APPLICATION
  return ResourceType.CLOUDHUB2_APPLICATION
}
